import React from 'react';
import AuthWrapper from "components/auth-wrapper/AuthWrapper";
import {MainTop} from "components/pages/groups/group-container/main-top/Main-top";
import {NotFoundContainer} from "components/pages/not-found/not-found-container/NotFoundContainer";

export const NotFound = () => {
    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop
                    title={''}
                    payment={false}
                    tabs={false}
                    setting={false}
                    link={'/'}
                />
                <NotFoundContainer/>
            </div>
        </AuthWrapper>
    );
};

